import React from "react";
import { Link, useLocation } from "react-router-dom";

import RatingStar from "../../../Common/RatingStar";
import { composeArrayForRatings } from "../../../Common/CommonMethods";

import ImageLoader from "../../../Common/ImageLoader";

const VerifiedBox = (props) => {
  let pgLocation = useLocation();

  const showTitleAndAlt = (pathname) => {
    const regex = new RegExp("/software|services/");
    return regex.test(pathname);
  };

  return (
    <li className={props.featured ? "sponsoredBlock" : ""}>
      {!!props.featured && (
        <div class="ribbon ribbon-top-right sponsored">
          <span>
            <div class="ribbonTxt">SPONSORED</div>
          </span>
        </div>
      )}
      <div className="categoryBox">
        <div className="left">
          <div className="vendorLogo">
            <Link to={props.profile_url}>
              <ImageLoader
                image={props.logo}
                fallbackImage={"/static/images/FC-Generic-Logo.webp"}
                showTitle={
                  pgLocation.pathname && showTitleAndAlt(pgLocation.pathname)
                }
                showAlt={
                  pgLocation.pathname && showTitleAndAlt(pgLocation.pathname)
                }
                title={`${props.total_references} ${props.name} Customer Reviews & References`}
                alt={`${props.name} logo`}
                width={165}
                height={70}
              />
            </Link>
          </div>
          {props.rating.aggregate_score ? (
            <div className="overallRating">
              <span className="ratingtxt">Overall Reference Rating</span>
              <span className="clsRating">
                {props.rating.aggregate_score}
                <RatingStar
                  starCount={composeArrayForRatings(
                    props.rating.aggregate_score
                  )}
                />
              </span>
            </div>
          ) : null}
        </div>
        <div className="middle">
          <div className="topHeader">
            <h2>
              <Link to={props.profile_url}>{props.name}</Link>
            </h2>
            <span className="clsBadgeContent verifiedBadge">Verified</span>
          </div>

          <span className="vendorCategory">{props.categoryName}</span>
          <div className="vendor_views">
            <ul>
              {props.casestudy_count ? (
                <li className="case_studies">
                  <Link to={`${props.profile_url}/case-studies`}>
                    <span className="count">{props.casestudy_count}</span>
                    Case Studies
                  </Link>
                </li>
              ) : null}
              {props.testimonial_count ? (
                <li className="testimonials">
                  <Link to={`${props.profile_url}/testimonials`}>
                    <span className="count">{props.testimonial_count}</span>
                    Testimonials
                  </Link>
                </li>
              ) : null}
              {props.video_count ? (
                <li className="videos">
                  <Link to={`${props.profile_url}/customer-videos`}>
                    <span className="count">{props.video_count}</span>
                    Videos
                  </Link>
                </li>
              ) : null}
            </ul>
          </div>
        </div>
        {props.total_references ? (
          <div className="right">
            <div className="btnReferences">
              <ul>
                <li className="view_profile">
                  <Link to={props.profile_url}>View Profile</Link>
                </li>
              </ul>
            </div>
          </div>
        ) : (
          <div className="right"></div>
        )}
      </div>
    </li>
  );
};

export default VerifiedBox;
